import { ChangeDetectionStrategy, Component, EventEmitter, Input, OnDestroy, OnInit, Output } from '@angular/core';
import { Observable, tap } from 'rxjs';
import { DeviceFile, Ref } from '@common/a2files-g/file.model';
import { FileUploadService, UploadState } from '@common/a2files-g/services/file-upload.service';

@Component({
  selector: 'lib-file-upload',
  templateUrl: './file-upload.component.html',
  styleUrls: ['./file-upload.component.scss'],
  providers: [
    {provide: FileUploadService},
  ],    
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class FileUploadComponent implements OnInit, OnDestroy {
  @Input() file2Upload: DeviceFile;
  @Input() path: string = "files";
  @Input() collection: string ;
  @Input() ref:Ref = null;
  @Input() type:string = 'file';
  @Output() state = new EventEmitter<UploadState>();
  uploadState$: Observable<UploadState>;

  hasError=false;

  constructor(
    private fileUploadService: FileUploadService
  ) { }

  ngOnInit(): void {
    const collection = this.collection ?? this.path
    const extra = {ref:this.ref, type: this.type}
    this.fileUploadService.uploadFile(this.file2Upload, this.path, collection, {extra});
    this.uploadState$ = this.fileUploadService.uploadState$.pipe(
      tap(uploadState =>{
        this.state.emit(uploadState)
      })
    )     
  }

  ngOnDestroy(){
  }

  onCancel(){
    this.fileUploadService.cancelUpload();
  }
}
